var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signatures-summary-badge"},[_c('div',{staticClass:"summary-signatures-icon"},[_c('icon',{attrs:{"name":"signature"}})],1),_c('span',{staticClass:"summary-signatures-text"},[_vm._v(_vm._s(_vm.summaryText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }